export function nowww(host: string) {
  if (host.startsWith("www.")) {
    return host.slice(4);
  }

  return host;
}

